import { Action } from 'redux';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { OpenWorkbookInDesktopDialog } from '../AppActionTypes';

export enum ContentType {
  Workbook = 'workbook',
  View = 'view'
}
export interface OpenWorkbookInDesktopAction extends Action {
  item: IContentInfo;
}

export function openWorkbookInDesktop(item: IContentInfo): OpenWorkbookInDesktopAction {
  return {
    type: OpenWorkbookInDesktopDialog,
    item
  };
}